import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@/elements/components/utils/convex-api";
import Loader from "@/elements/components/shared/loader";
import React from "react";
import StudentNoShowScreen from "@/elements/components/no-show/student-no-show";

function ReportStudentNoShowScreen() {
  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {})
  );

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  return <StudentNoShowScreen />;
}

export default ReportStudentNoShowScreen;
